// extracted by mini-css-extract-plugin
export var closeButton = "_50-0";